
import EventManager from "@/components/shared/EventManager.vue";

export default {
    name: 'App',
    components: {EventManager},
}
